// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ECcEm","wrapper":"Button_wrapper__15Rex"};